<div class="modal-header">
    <h5 class="modal-title text-capitalize" id="myModalLabel">Your Devices</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
        (click)="onClose('cancel')"></button>
</div>
<div class="modal-body">
    <div class="container">
        <div class="info">You're currently signed in on these devices. Some devices may display multiple activity
            sessions for the same login.</div>
        <!-- <div class="device-list">
            
            <div class="device-group">
                <div class="device-title">2 sessions on Windows computer(s)</div>
                <div class="device">
                    <div>
                        <img src="../../../assets/icons/windows-login-device.svg" alt="" srcset="">
                    </div>
                    <div class="device-details">
                        <div>Windows</div>
                        <div>Cottage Lake, WA, USA</div>
                        <div>Google Chrome</div>
                        <div>Login In: 02/12/2024 · 10:09 AM</div>
                    </div>
                    <div class="icon">
                        <img src="../../../assets/icons/logout-device.svg" alt="" srcset="">
                    </div>
                </div>
                <div class="device">
                    <div class="device-details">
                        <div>Windows</div>
                        <div>Cottage Lake, WA, USA</div>
                        <div>Microsoft Edge</div>
                        <div>Login In: 01/12/2024 · 12:00 PM</div>
                    </div>
                    <div class="icon">
                        <img src="../../../assets/icons/logout-device.svg" alt="" srcset="">
                    </div>
                </div>
            </div>
            
            <div class="device-group">
                <div class="device-title">1 session on iPhone</div>
                <div class="device">
                    <div>
                        <img src="../../../assets/icons/mobile-login-devices.svg" alt="" srcset="">
                    </div>
                    <div class="device-details">
                        <div>iPhone</div>
                        <div>Cottage Lake, WA, USA</div>
                        <div>Google Chrome</div>
                        <div>Login In: 02/12/2024 · 11:40 AM</div>
                    </div>
                    <div class="icon">
                        <img src="../../../assets/icons/logout-device.svg" alt="" srcset="">
                    </div>
                </div>
            </div>
        </div> -->
        <div class="device-list">
            <div *ngFor="let deviceGroup of loginDeviceList" class="device-group">
                <div class="device-title">
                    @if(deviceGroup.os == 'IOS'){
                    {{ deviceGroup.sessionCount }} session{{ deviceGroup.sessionCount > 1 ? 's' : '' }} on {{
                    deviceGroup.os }} device(s)
                    }
                    @else if (deviceGroup.os == 'Android') {
                    {{ deviceGroup.sessionCount }} session{{ deviceGroup.sessionCount > 1 ? 's' : '' }} on {{
                    deviceGroup.os }} device(s)
                    }
                    @else {
                    {{ deviceGroup.sessionCount }} session{{ deviceGroup.sessionCount > 1 ? 's' : '' }} on {{
                    deviceGroup.os == 'OSX' ? 'Mac' : deviceGroup.os }} computer(s)
                    }
                </div>

                <div *ngFor="let session of deviceGroup.sessions; let i = index" class="device row">
                    <!-- Image will only be shown for the first session -->
                    <div *ngIf="i === 0" class="col-3 d-flex justify-content-center">
                        <img *ngIf="deviceGroup.os === 'Windows'" src="../../../assets/icons/windows-login-device.svg"
                            alt="Windows Icon" />
                        <img *ngIf="deviceGroup.os === 'IOS'" src="../../../assets/icons/iphone-login-devices.svg"
                            alt="iPhone Icon" />
                        <img *ngIf="deviceGroup.os === 'OSX'" src="../../../assets/icons/mac-login-devices.svg"
                            alt="Mac Icon" />
                        <img *ngIf="deviceGroup.os === 'Android'" src="../../../assets/icons/android-login-devices.svg"
                            alt="Android Icon" />
                        <img *ngIf="deviceGroup.os.includes('Linux')" src="../../../assets/icons/lunix-login-devices.svg"
                            alt="Lunix Icon" />
                    </div>
                    <div *ngIf="i > 0" class="col-3">

                    </div>

                    <div class="device-details col-6">
                        <hr *ngIf="i > 0">
                        <div>{{ session.os }}</div>
                        <div>{{ session.cityName }}, {{ session.stateName }}, {{ session.countryName }}</div>
                        <div>{{ session.browserName }}</div>
                        <div>
                            Login In: {{ convertUTCToLocal(session.lastAccessed) | date : 'dd/MM/yyyy hh:mm a' }}
                        </div>
                    </div>
                    <div class="col-3 d-flex justify-content-center">
                        <div class="icon" (click)="logoutDevice(session.loginTokenId)">
                            <img src="../../../assets/icons/logout-device.svg" alt="Logout Icon" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>